import React from 'react';
import { Helmet } from 'react-helmet';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact | Royal Nails Pro - Prendre Rendez-vous Genève</title>
        <link rel="canonical" href="https://royalnailspro.ch/contact" />
        <meta
          name="description"
          content="Contactez Royal Nails Pro à Genève pour prendre rendez-vous. Adresse: Avenue Pictet-de-Rochemont 19, 1207 Genève. Téléphone: +41783118784"
        />
        <meta
          name="keywords"
          content="contact Royal Nails Pro, rendez-vous manucure Genève, adresse salon ongles Genève, téléphone salon beauté Genève, localisation Royal Nails Pro"
        />
        
        {/* Open Graph / Facebook & Instagram */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://royalnailspro.ch/contact" />
        <meta property="og:title" content="Contact | Royal Nails Pro - Prendre Rendez-vous Genève" />
        <meta property="og:description" content="Contactez Royal Nails Pro à Genève pour prendre rendez-vous. Avenue Pictet-de-Rochemont 19, 1207 Genève." />
        <meta property="og:image" content="https://royalnailspro.ch/images/logo.png" />
        <meta property="og:image:secure_url" content="https://royalnailspro.ch/images/logo.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:alt" content="Contact Royal Nails Pro" />
        <meta property="article:author" content="https://www.facebook.com/people/Rodyka-Soltan/61572131475024/" />
        
        {/* Instagram specific */}
        <meta property="instagram:creator" content="@rodyka_soltan" />
        
        {/* TikTok */}
        <meta name="tiktok:creator" content="@rodicasoltan" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact | Royal Nails Pro" />
        <meta name="twitter:description" content="Contactez Royal Nails Pro à Genève pour prendre rendez-vous." />
        <meta name="twitter:image" content="https://royalnailspro.ch/images/logo.png" />
        <meta name="twitter:site" content="@rodyka_soltan" />
        <meta name="twitter:creator" content="@rodyka_soltan" />
      </Helmet>

      <div className="back_re">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <h2>Contactez-nous</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact" style={{ marginBottom: '25px' }}>
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-8">
              <div className="mb-4">
                <a
                  className="get-in-touch-btn mb-2"
                  href="https://www.instagram.com/rodyka_soltan?igsh=MW84cjRreW9tbnJrZQ=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Suivez-nous sur Instagram
                </a>
                <br />
                <a
                  className="get-in-touch-btn btn-lg"
                  href="https://salonkee.ch/salon/soltan-rodyka-nails?lang=fr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Réserver un Rendez-vous
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="map-responsive border rounded shadow-sm overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA0s1a7phLN0iaD6-UE7m4qP-z21pH0eSc&q=Av.+Pictet-de-Rochemont+19,+1207+Genève,+Switzerland"
                  width="100%"
                  height="400"
                  frameBorder="0"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Location Map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;

